import React from 'react';
import { Popover } from '@mui/material';
import { Button } from 'react-bootstrap';
import { ContactList } from './ContactList';

interface BatteryBellNotificationProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  open: boolean;
}

const BatteryBellNotification: React.FC<BatteryBellNotificationProps> = ({
  anchorEl,
  setAnchorEl,
  open,
}) => {
  return (
    <div className="battery-bell">
      <Button variant="transparent" onClick={(event) => setAnchorEl(event.currentTarget)}>
        <i className="fa fa-bell fa-lg icon-primary ms-1 mx-auto" />
      </Button>

      <Popover
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <ContactList />
      </Popover>
    </div>
  );
};

export default BatteryBellNotification;
